import axios from "axios";

const isLocalDev =
        window.location.hostname === "localhost" &&
        window.location.port === "5800";

const bffBase = isLocalDev
  ? "https://localhost:5700"   // dev: hit BFF on 5700
  : "https://bff.dashboard.smallsoft.com.au";    //TODO: remove the hardcoded. 

export const API = axios.create({
  baseURL: bffBase,
  withCredentials: true,   // ⭐ MUST send cookies
  timeout: 30000,
});

// =============================================================
// Response Interceptor — Auto redirect on 401 (no dashboard session)
// =============================================================
API.interceptors.response.use(
  (res) => res,
  (err) => {
    if (err.response?.status === 401) {
      // auth expired / invalid
      // do NOT redirect here
      // just let callers react
    }

    return Promise.reject(err);
  }
);

export default API;